/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SignalAlarmRuleInput
 */
export interface SignalAlarmRuleInput {
  /**
   *
   * @type {string}
   * @memberof SignalAlarmRuleInput
   */
  signalAlarmRuleId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalAlarmRuleInput
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof SignalAlarmRuleInput
   */
  businessDayThreshold: number;
  /**
   *
   * @type {string}
   * @memberof SignalAlarmRuleInput
   */
  description?: string | null;
}

/**
 * Check if a given object implements the SignalAlarmRuleInput interface.
 */
export function instanceOfSignalAlarmRuleInput(
  value: object,
): value is SignalAlarmRuleInput {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    !("businessDayThreshold" in value) ||
    value["businessDayThreshold"] === undefined
  )
    return false;
  return true;
}

export function SignalAlarmRuleInputFromJSON(json: any): SignalAlarmRuleInput {
  return SignalAlarmRuleInputFromJSONTyped(json, false);
}

export function SignalAlarmRuleInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SignalAlarmRuleInput {
  if (json == null) {
    return json;
  }
  return {
    signalAlarmRuleId:
      json["signalAlarmRuleId"] == null ? undefined : json["signalAlarmRuleId"],
    name: json["name"],
    businessDayThreshold: json["businessDayThreshold"],
    description: json["description"] == null ? undefined : json["description"],
  };
}

export function SignalAlarmRuleInputToJSON(json: any): SignalAlarmRuleInput {
  return SignalAlarmRuleInputToJSONTyped(json, false);
}

export function SignalAlarmRuleInputToJSONTyped(
  value?: SignalAlarmRuleInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    signalAlarmRuleId: value["signalAlarmRuleId"],
    name: value["name"],
    businessDayThreshold: value["businessDayThreshold"],
    description: value["description"],
  };
}
